import { __decorate, __metadata } from "tslib";
import { LengthWithLVS } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsOptional, IsString } from 'class-validator';
import { VendorExposeGroup } from '../interface';
export class PatchBaseMetadataDto {
}
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Tattle merchant id', example: '390ac86f03e0c6b46f243c7980739887' }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(5, 250, { always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", String)
], PatchBaseMetadataDto.prototype, "tattleMerchantId", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Tattle store id', example: '777' }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(3, 250, { always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", String)
], PatchBaseMetadataDto.prototype, "tattleStoreId", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", Boolean)
], PatchBaseMetadataDto.prototype, "isTattleIntegrationEnabled", void 0);
//# sourceMappingURL=PatchBaseMetadataDto.js.map